import {
  ChefHat,
  Table,
  IceCream,
  DollarSign,
  ShoppingCart,
  LayoutDashboard,
  BarChart,
  Tag,
  Package,
  FileText,
  Shuffle,
  User,
  Settings,
  LogOut,
  MessageCircle,
  TrendingUp,
  Users,
  ShoppingBag,
} from 'lucide-react';
import React from 'react';

export interface MenuItem {
  label: string;
  path: string;
  icon?: React.ReactElement;
}

export const menuItems: MenuItem[] = [
  { label: 'Dashboard', path: '/dashboard', icon: <BarChart size={20} /> },
  { label: 'KPIs', path: '/kpi', icon: <LayoutDashboard size={20} /> },
  { label: 'Inventario', path: '/inventory', icon: <Package size={20} /> },
  { label: 'Compras', path: '/purchases', icon: <ShoppingCart size={20} /> },
  { label: 'Proveedores', path: '/purchases/suppliers', icon: <Users size={20} /> },
  { label: 'WhatsApp Bot', path: '/whatsapp', icon: <MessageCircle size={20} /> },
  { label: 'Categorias', path: '/categories', icon: <Tag size={20} /> },
  { label: 'Productos', path: '/products', icon: <Package size={20} /> },
  { label: 'Sabores', path: '/flavors', icon: <IceCream size={20} /> },
  { label: 'Swagger', path: '/swagger', icon: <FileText size={20} /> },
  { label: 'Mesas', path: '/tables', icon: <Table size={20} /> },
  { label: 'POS', path: '/pos', icon: <ShoppingCart size={20} /> },
  { label: 'Cocina', path: '/kitchen', icon: <ChefHat size={20} /> },
  { label: 'Caja', path: '/cash', icon: <DollarSign size={20} /> },
  { label: 'Movimientos', path: '/cash/movements', icon: <Shuffle size={20} /> },
  { label: 'Profile', path: '/profile', icon: <User size={20} /> },
  { label: 'Configuración', path: '/settings', icon: <Settings size={20} /> },
  { label: 'Logout', path: '/logout', icon: <LogOut size={20} /> },
];
